import {
  IReportEvents,
  IUserReportAddResult,
  TStiReportData,
  TUserReportResultKindEnum,
} from '@infotech-soe/merps/types/Reports';
import { ActionName, ExecutedActionP, tg } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../infrastructure/providers/abstract/IApiProvider';
import MerpsApiProvider from '../../infrastructure/providers/pb-adapter/MerpsApiProvider';
import { ClientContext } from '../context/IContextService';
import PrintService from '../print/PrintService';

import { downloadFileFromBlob } from './files';

export type ReviewArgs = {
  data: TStiReportData['data'];
  template: string;
  vars?: Record<string, any>;
  events?: IReportEvents;
  parseDates?: boolean;
};

export type ExecutePrintActionReturn = IUserReportAddResult | ReviewArgs;

export const executePrintAction = async (
  action: ActionName,
  context: ClientContext,
  args: TActionArgsValues,
  actionSchema: ExecutedActionP
): Promise<ExecutePrintActionReturn> => {
  const { streams } = new MerpsApiProvider();
  const printService = new PrintService();

  if (!tg.isPrintAction(actionSchema))
    throw new Error(
      `Wrong action schema type. Expected "Print" but got: "${actionSchema.Type}"`
    );
  const reportResult = await printService.getExportedReport(
    action,
    context.toServerContext(),
    args
  );
  if (
    'kind' in reportResult &&
    reportResult.kind === TUserReportResultKindEnum.STREAM
  ) {
    void streams
      .read(reportResult.id)
      .then(buffer =>
        downloadFileFromBlob(`${reportResult.reportName || 'report'}`, buffer)
      );
    return reportResult;
  } else if ('data' in reportResult) {
    const { data, opts } = reportResult;
    return {
      data,
      template: opts?.templateCode ?? actionSchema.TemplateCode,
      vars: opts?.variables,
      events: opts?.events,
      parseDates: opts?.parseDates,
    };
  } else {
    throw new Error(`Unknown print action schema type`);
  }
};
